module.exports = "/dashboard/images/image-placeholder.png?67c4000c76cce9e8bcda14a2b61a10e6";